import styled from 'styled-components';

const ButtonWrapper = ({ children }) => {
  return <Wrapper>{children}</Wrapper>;
};

export default ButtonWrapper;

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  gap: 8px;
  justify-content: ${props => props.theme.button.align};

  button {
    white-space: nowrap;
    flex: ${props => (props.theme.button.align === 'stretch' ? '1' : '0')};
  }
`;
